import { Controller } from "stimulus"

// Filters table rows as the user types. Drop it on any wrapper containing a
// search input and a set of rows:
//
//   <div data-controller="table-filter">
//     <input data-table-filter-target="input" data-action="input->table-filter#filter">
//     <tr data-table-filter-target="row" data-filter-text="rashad quigley lee@...">
//     <tr data-table-filter-target="empty" hidden>...</tr>
//
// Rows match on `data-filter-text`, falling back to their text content, so each
// view decides exactly which columns are searchable.
export default class extends Controller {
  static targets = ["input", "row", "empty"]

  connect() {
    if (this.hasInputTarget) this.filter()
  }

  filter() {
    const term = this.inputTarget.value.trim().toLowerCase()
    let matches = 0

    this.rowTargets.forEach((row) => {
      const hit = term === "" || this.searchText(row).includes(term)
      row.hidden = !hit
      if (hit) matches++
    })

    if (this.hasEmptyTarget) this.emptyTarget.hidden = matches > 0
  }

  searchText(row) {
    const text = "filterText" in row.dataset ? row.dataset.filterText : row.textContent
    return text.toLowerCase()
  }
}
